import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import { CreateActionContext } from "./CreateActionContext";
import CombinationForm from "@beeldit/ecommerce/combinations/components/CombinationForm";

function useCreateAction(index: any, formDefaultValues: any = {}): any {
  const initialize = useInitialize();
  const initializeFunction = () => initialize(formDefaultValues);

  /**
   * Form store success function definition
   */
  const onSuccessStore = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const store = useStore();
  const storeFunction = (dataOverride?: any) => store(onSuccessStore, dataOverride);

  const contextInstance = useContext(CreateActionContext);
  const { element, setShowModal } = contextInstance;

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "create_combination",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    size: "modal-lg",
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: (e: any) => {
      storeFunction(e.formData);
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: CreateActionContext,
    className: "combination-form",
    showDiscount: true
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <CombinationForm formConfig={formConfig} />
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    initializeFunction,
    actionTemplate,
  };
}

export default useCreateAction;
